import { render, staticRenderFns } from "./UserSessionsPage.vue?vue&type=template&id=742a4fa2&"
import script from "./UserSessionsPage.vue?vue&type=script&lang=js&"
export * from "./UserSessionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports